module.exports = __webpack_public_path__ + "static/media/strefa-coaching.de56f9b5.svg";